import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class CertificationsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      result: '',
      expire: '',
      expire_type: 'day_format',
      hours: '',
      aircraft_model_id: '',
      aircraft_models_list: [],
      certification_type_id: '',
      presence_type: '',
      offshore: 0,
      jungle: 0,
      night_landings: 0,
      certification_types_list: [],
      training_certification_type_id: '',
      training_certification_types_list: [],
      presence_list: [
        {value: 0, label: this.locale.Certificados.AdicionarCerfiticado.opcoesPresenca.Presenca},
        {value: 1, label: this.locale.Certificados.AdicionarCerfiticado.opcoesPresenca.EAD},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificado/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({training_certification_types_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificado/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({certification_types_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de tipos de certificado */ }); /* Lista de tipos de treinamento de certificado */
    });
  }

  add(event) {
    event.preventDefault();
    if(!(this.state.training_certification_type_id)){
      this.setState({overlay: {message: this.locale.Certificados.AdicionarCerfiticado.mensagemSelecioneDestinado, type: 'error', status: 'open'}});
    } else if(!(this.state.certification_type_id)){
      this.setState({overlay: {message: this.locale.Certificados.AdicionarCerfiticado.mensagemSelecioneTipo, type: 'error', status: 'open'}});
    } else if(!(this.state.name)){
      this.setState({overlay: {message: this.locale.Certificados.AdicionarCerfiticado.mensagemSelecioneTipo, type: 'error', status: 'open'}});
    } else {
      var datasave = {
        name: this.state.name,
        aircraft_model_id: this.state.aircraft_model_id,
        certification_type_id: this.state.certification_type_id,
        presence_type: this.state.presence_type,
        training_certification_type_id: this.state.training_certification_type_id,
        result: this.state.result,
        expire: this.state.expire,
        expire_type: this.state.expire_type,
        hours: this.state.hours,
        offshore: this.state.offshore,
        jungle: this.state.jungle,
        night_landings: this.state.night_landings,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/certificado/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          }
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Certificados.AdicionarCerfiticado.titulo}</h3>
      <Link to="/certificados" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.RegistroDeCertificado} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.TipoDeVencimento}:</label>
              <Select
                className="form-field-name"
                name="expire_type"
                value={this.state.expire_type}
                searchable={true}
                placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.SelecionarTipoDeVencimento}
                onChange={this.handleSelectChange.bind(this, 'expire_type')}
                options={[
                  {value: "day_format", label: this.locale.Certificados.AdicionarCerfiticado.formulario.opcoesVencimento.VencimentoPorDia},
                  {value: "month_year_format", label: this.locale.Certificados.AdicionarCerfiticado.formulario.opcoesVencimento.VencimentoPorMes},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.Modelo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.SelecionarModeloDeAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="certification_type_id"
                value={this.state.certification_type_id}
                searchable={true}
                placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'certification_type_id')}
                options={this.state.certification_types_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.DestinadoA}:</label>
              <Select
                className="form-field-name"
                name="training_certification_type_id"
                value={this.state.training_certification_type_id}
                searchable={true}
                placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'training_certification_type_id')}
                options={this.state.training_certification_types_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.NotaMinima}:</label>
                <InputMask value={this.state.result}  maskChar={null} name="result" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'result')} placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.NotaMinimaParaValidacaoDoCertificado} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.Validade}:</label>
                <InputMask value={this.state.expire}  maskChar={null} name="expire" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.ValidadeEmMesesDoCertificado} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.CargaHoraria}:</label>
                <InputMask value={this.state.hours}  maskChar={null} name="hours" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder={this.locale.Certificados.AdicionarCerfiticado.formulario.placeholder.CargaHorariaDoCertificado}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.ContaExperienciaOffShore}:</label>
              <br/>
                <Toggle
                  checked={this.state.offshore}
                  aria-label='No label tag'
                  name="offshore"
                  onChange={this.handleToggleChange.bind(this, 'offshore')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.ContaExperienciaSelva}:</label>
              <br/>
                <Toggle
                  checked={this.state.jungle}
                  aria-label='No label tag'
                  name="jungle"
                  onChange={this.handleToggleChange.bind(this, 'jungle')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Certificados.AdicionarCerfiticado.formulario.ExperienciaNoturna}:</label>
              <br/>
                <Toggle
                  checked={this.state.night_landings}
                  aria-label='No label tag'
                  name="night_landings"
                  onChange={this.handleToggleChange.bind(this, 'night_landings')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.AdicionarCerfiticado.formulario.botaoAdicionarCertificado}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default CertificationsAdd;




// WEBPACK FOOTER //
// ./src/Components/Certifications/CertificationsAdd.js